var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "27.425",
        height: "27.425",
        viewBox: "586.506 566.575 27.425 27.425",
      },
    },
    [
      _c("g", { attrs: { "data-name": "time-svgrepo-com-4" } }, [
        _c("path", {
          attrs: {
            d: "M603.66 582.892a4.717 4.717 0 0 0 2.355.627 4.753 4.753 0 0 0 4.748-4.748 4.753 4.753 0 0 0-4.748-4.748c-.058 0-.116.003-.173.005a9.81 9.81 0 0 0-9.525-7.453c-5.41 0-9.81 4.401-9.81 9.81 0 5.41 4.4 9.812 9.81 9.812a9.707 9.707 0 0 0 4.466-1.074 9.9 9.9 0 0 0 2.877-2.231Zm5.406-4.12a3.055 3.055 0 0 1-3.051 3.051 3.055 3.055 0 0 1-3.052-3.052 3.055 3.055 0 0 1 3.052-3.051 3.055 3.055 0 0 1 3.051 3.051Zm-20.863-2.386c0-4.475 3.64-8.115 8.114-8.115a8.07 8.07 0 0 1 7.868 6.12 4.755 4.755 0 0 0-2.918 4.38c0 1.15.411 2.207 1.095 3.03a8.04 8.04 0 0 1-6.045 2.7c-4.474 0-8.114-3.64-8.114-8.115Z",
            fill: _vm.color || "#1f1f1f",
            "fill-rule": "evenodd",
            "data-name": "Path 791",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "m595.469 575.529-5.289.009.003 1.696 6.982-.012v-6.972h-1.696v5.279Z",
            fill: _vm.color || "#1f1f1f",
            "fill-rule": "evenodd",
            "data-name": "Path 792",
          },
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d: "M606.015 585.235c-4.365 0-7.917 3.552-7.917 7.917V594h15.833v-.848c0-4.365-3.551-7.917-7.916-7.917Zm-6.163 7.069a6.234 6.234 0 0 1 5.315-5.314v3.9h1.696v-3.9a6.234 6.234 0 0 1 5.314 5.314h-12.325Z",
            fill: _vm.color || "#1f1f1f",
            "fill-rule": "evenodd",
            "data-name": "Path 793",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }